import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import { SocialIcon } from "react-social-icons";
import avatar from "./images/my_imgs/avatar.png";
import { bioStyle } from "./components/styles";
import Typewriter from "./components/Typewriter"; // Adjust the path if necessary

const Header = () => {
  return (
    <Row className="hero">
      <Col
        xs={{ span: 12, order: 1 }}
        sm={{ span: 12, order: 1 }}
        md={{ span: 6, order: 1 }}
        lg={{ span: 7, order: 1 }}
        className="hero-copy"
      >
        <Typewriter text="Hi, I'm Dustin" speed={80} />
        <p style={{ ...bioStyle, maxWidth: "720px" }} className="hero-body">
          I'm currently a Software Engineer at Pathify, where I got to build
          tools that students and educators use every day. Lovely to connect and
          chat about all things tech, startups, and life!
        </p>
        <div className="hero-actions">
          <SocialIcon
            url="https://www.linkedin.com/in/vuminhduc796/"
            style={{ width: 42, height: 42 }}
          />
          <SocialIcon
            url="https://www.facebook.com/vuminhduc30/"
            style={{ width: 42, height: 42 }}
          />
          <SocialIcon
            url="https://github.com/vuminhduc796"
            style={{ width: 42, height: 42 }}
          />
        </div>
      </Col>
      <Col
        xs={{ span: 12, order: 1 }}
        sm={{ span: 12, order: 1 }}
        md={{ span: 6, order: 2 }}
        lg={{ span: 5, order: 2 }}
        style={{ textAlign: "center" }}
      >
        <a
          href="https://www.instagram.com/mjnduc/"
          target="_blank"
          rel="noreferrer"
          className="hero-image-shell"
        >
          <Image src={avatar} alt="Dustin Vu" className="hero-image" />
        </a>
      </Col>
    </Row>
  );
};

export default Header;
